import { isValidDateString } from './dateTimeUtils';

// General Utilities
export const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
export const isValidPhoneNumber = (phone) => /^\d{10}$/.test(phone?.toString());

// === STUDENT VALIDATION ===

const csvStudentTemplate = {
    studentId: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    studentAddress: '',
    classes: '',
    studentCreationDate: '',
    activationStatus: true,
};

export const validateCSVHeaders = (actualHeaders, type = 'student') => {
    const expectedHeaders = type === 'inventory'
        ? getInventoryHeaders()
        : Object.keys(csvStudentTemplate);

    const missingHeaders = expectedHeaders.filter(h => !actualHeaders.includes(h));
    const extraHeaders = actualHeaders.filter(h => !expectedHeaders.includes(h));

    return { missingHeaders, extraHeaders };
};

export const validateStudentRow = (student) => {
    const errors = [];

    if (!isValidEmail(student.email)) {
        errors.push("Invalid email address");
    }

    if (!isValidPhoneNumber(student.phoneNumber)) {
        errors.push("Invalid phone number");
    }

    if (typeof student.activationStatus !== "boolean") {
        errors.push("Invalid activation status (must be true/false)");
    }

    if (
        student.studentCreationDate &&
        !isValidDateString(student.studentCreationDate)
    ) {
        errors.push("Invalid studentCreationDate (must be YYYY-MM-DD)");
    }

    return errors;
};

// === INVENTORY VALIDATION ===

export const getInventoryHeaders = () => [
    "item", "type", "typeDescription", "serialNo", "assetCondition", "manufacturer",
    "model", "hyperlink", "purchaseDate", "purchaseCost", "location", "allowedTime",
    "checkedOut", "allowedClasses", "notes"
];

export const validateInventoryRow = (row) => {
    const errors = [];

    if (!row.item || !row.serialNo) {
        errors.push("Missing required fields (item, serialNo)");
    }

    if (row.purchaseCost && isNaN(parseFloat(row.purchaseCost))) {
        errors.push("Invalid purchase cost");
    }

    if (row.purchaseDate && !isValidDateString(row.purchaseDate)) {
        errors.push("Invalid purchase date format (expected YYYY-MM-DD)");
    }

    // Validate allowedTime (rental duration) if provided
    if (row.allowedTime && row.allowedTime.trim() !== '') {
        const duration = parseInt(row.allowedTime.trim(), 10);
        if (isNaN(duration) || duration <= 0) {
            errors.push("Invalid rental duration (allowedTime must be a positive number)");
        }
    }

    return errors;
};
